import type { Modal } from '@ps/web-core-store';

import { CRMZone } from '../enums';

export interface EmbeddedNavigationProps {
  modal: Modal;
  c2l: string;
  c2lMobile?: string;
}

export const OptInZone: EmbeddedNavigationProps = {
  modal: {
    path: `/stars-crm/${CRMZone.STARS_REWARDS_OPT_IN}`,
    locationState: { icon: 'light', componentType: 'Single' }
  },
  c2l: 'starsrewards/optin'
};

export const InfoZone: EmbeddedNavigationProps = {
  modal: {
    path: `/stars-crm/${CRMZone.STARS_REWARDS_INFO}`,
    locationState: { hasCloseBtn: false, componentType: 'Single', scrolling: 'yes' }
  },
  c2l: 'starsrewards/info'
};

export const ChestOpening: EmbeddedNavigationProps = {
  modal: {
    path: '/account/open-chest'
  },
  c2l: 'starsrewards/chest',
  c2lMobile: 'starsrewards/chest/-1'
};

export const Deal: EmbeddedNavigationProps = {
  modal: {
    path: '/account/the-deal'
  },
  c2l: 'play-the-deal'
};
